import {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  ME_LOGOUT,
  ME_LOGOUT_SUCCESS,
  ME_LOGOUT_ERROR,
} from '../actions';

const INIT_STATE = {
  loading: false,
  error: '',
  profile: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROFILE:
      return { ...state, loading: true };
    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: action.payload,
        error: '',
      };
    case GET_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case ME_LOGOUT:
      return { ...state, loading: true };
    case ME_LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        profile: {},
        error: '',
      };
    case ME_LOGOUT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return { ...state };
  }
};
